<template>
  <div>
    <webix-ui :config="webixUI"/>
    <router-view></router-view>
  </div>
</template>

<script>
  //import { webixUI, init } from './reportPage';
  import timeLogListView from './include/timeLogList';
  import costsListView from './include/costsList';
  import globalStore from '$$globalStore';

  const reportsMap = {
    'timeloglist': timeLogListView,
    'costslist': costsListView
    //
  };

  export default {
    props: {
      type: {
        type: String,
        default: null
      },
    },
    name: 'reportPage',
    data() {
      let component = this;
      return {
      }
    },
    computed: {
      currentFilter() {
        return globalStore.getters['filter/currentFilter'];
      },
    },
    created() {
      this.webixUI = reportsMap[this.type].webixUI;
    },
    mounted: function () {
      let component = this;

      this.$nextTick(function () {
        reportsMap[component.type].init()
      });
    },
    watch: {
      currentFilter(value) {
        reportsMap[this.type].filterTableData();
      },
    },
  }
</script>

<style scoped>

</style>
